import {ProMapSection} from '../types/pro-map-section.types'
import {ProMapSectionFieldsFragment} from '../../../../__generated__/datocms.types'

export function parseProMapSection(s: ProMapSectionFieldsFragment): ProMapSection {
  return {
    __type: 'ProMapSection',
    id: s.id,
    title: s.title,
  }
}
